import { render, staticRenderFns } from "./SelectCategory.vue?vue&type=template&id=296b4a10&scoped=true&"
import script from "./SelectCategory.vue?vue&type=script&lang=js&"
export * from "./SelectCategory.vue?vue&type=script&lang=js&"
import style0 from "./SelectCategory.vue?vue&type=style&index=0&id=296b4a10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296b4a10",
  null
  
)

export default component.exports